/**
 * Resolves a responsive value to Tailwind class names using pre-defined class maps.
 * Accepts either a static value (looked up in baseClasses) or a breakpoint-keyed object
 * (looked up in breakpointClasses).
 */
export const resolveResponsiveClasses = (value, baseClasses, breakpointClasses) => {
    if (value == null)
        return '';
    if (typeof value === 'string' || typeof value === 'number') {
        return baseClasses[value] ?? '';
    }
    return Object.entries(value)
        .map(([bp, v]) => breakpointClasses[bp]?.[v] ?? '')
        .filter(Boolean)
        .join(' ');
};
//# sourceMappingURL=resolveResponsiveClasses.js.map